/* assets/falp-sliders.js — wire up both sliders on /pages/falp */
(function () {
  function initReviewsSlider(root) {
    if (!root || root.dataset.enhanced) return;
    root.dataset.enhanced = '1';

    const track  = root.querySelector('.track');
    const slides = track ? Array.from(track.querySelectorAll('.card')) : [];
    const prev   = root.querySelector('.prev');
    const next   = root.querySelector('.next');

    if (!track || !slides.length) return;

    // dots (create if missing)
    let dotsWrap = root.querySelector('.dots');
    if (!dotsWrap) {
      dotsWrap = document.createElement('div');
      dotsWrap.className = 'dots';
      dotsWrap.setAttribute('role','tablist');
      dotsWrap.setAttribute('aria-label','Choose review to view');
      root.appendChild(dotsWrap);
    }
    dotsWrap.innerHTML = '';
    slides.forEach((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role','tab');
      b.setAttribute('aria-label','Go to review ' + (i+1));
      b.addEventListener('click', () => goTo(i));
      dotsWrap.appendChild(b);
    });

    let index = 0;
    const dots = () => dotsWrap.querySelectorAll('button');
    const updateDots = (i) => dots().forEach((d, j) => d.setAttribute('aria-selected', j === i ? 'true' : 'false'));
    const w = () => track.clientWidth;
    const current = () => Math.round(track.scrollLeft / w());
    const clamp = (n, min, max) => Math.max(min, Math.min(n, max));
    const goTo = (i) => track.scrollTo({ left: i * w(), behavior: 'smooth' });
    const step = (dir) => { index = clamp(current() + dir, 0, slides.length - 1); goTo(index); };

    updateDots(0);
    track.addEventListener('scroll', () => { const i = current(); if (i !== index) { index = i; updateDots(i); } }, { passive: true });
    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));

    let t; window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(() => goTo(current()), 120); });
  }

  function initProductsSlider(root) {
    if (!root || root.dataset.enhanced) return;
    root.dataset.enhanced = '1';

    const slider = root.querySelector('#productsSlider');
    const slides = slider ? Array.from(slider.querySelectorAll('.ps-slide')) : [];
    const prev   = root.querySelector('.ps-prev');
    const next   = root.querySelector('.ps-next');

    if (!slider || !slides.length) return;

    // dots (use existing #psDots or create)
    let dots = root.querySelector('#psDots');
    if (!dots) {
      dots = document.createElement('div');
      dots.id = 'psDots';
      dots.className = 'ps-dots';
      dots.setAttribute('role','tablist');
      dots.setAttribute('aria-label','Choose product');
      root.appendChild(dots);
    }
    dots.innerHTML = '';
    slides.forEach((_, i) => {
      const b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('role','tab');
      b.setAttribute('aria-label','Go to product ' + (i+1));
      b.addEventListener('click', () => goTo(i));
      dots.appendChild(b);
    });

    let index = 0;
    const updateDots = (i) => dots.querySelectorAll('button').forEach((d, j) => d.setAttribute('aria-selected', j === i ? 'true' : 'false'));
    const w = () => slider.clientWidth;
    const current = () => Math.round(slider.scrollLeft / w());
    const goTo = (i) => slider.scrollTo({ left: i * w(), behavior: 'smooth' });
    const clamp = (n, min, max) => Math.max(min, Math.min(n, max));
    const step = (dir) => { index = clamp(current() + dir, 0, slides.length - 1); goTo(index); };

    updateDots(0);
    slider.addEventListener('scroll', () => { const i = current(); if (i !== index) { index = i; updateDots(i); } }, { passive: true });
    if (prev) prev.addEventListener('click', () => step(-1));
    if (next) next.addEventListener('click', () => step(1));
    slider.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
      if (e.key === 'ArrowLeft')  { e.preventDefault(); step(-1); }
    });

    let t; window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(() => goTo(current()), 120); });
  }

  function boot() {
    // Reviews (Section 11)
    document.querySelectorAll('#folic-acid-lp .reviews11').forEach(initReviewsSlider);
    // Products (Section 14)
    initProductsSlider(document.querySelector('#folic-acid-lp .products'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
})();